<div class="document-content-body">
  <form [formGroup]="form">
    <ng-container
      *ngFor="
        let item of blocks | orderBy : 'order';
        index as i;
        trackBy: trackBy
      "
    >
      <div
        class="doc-block"
        [ngClass]="{
          'doc-padding': item.type !== blockTypes.PAGE_BREAK,
          'doc-block-hidden': item.hidden
        }"
      >
        <div class="doc-block-inner">
          <ng-container [ngSwitch]="item.type">
            <ng-container *ngSwitchCase="blockTypes.EDITOR">
              <ng-container *ngIf="blockGuards.isEditor(item)">
                <div class="doc-block-visibility">
                  <editor
                    [apiKey]="editorOptions.apiKey"
                    [initialValue]="item.initialValue"
                    [inline]="true"
                    [plugins]="editorOptions.plugins"
                    [init]="editorOptions.options"
                    [toolbar]="editorOptions.toolbar"
                    [formControlName]="item.id"
                  >
                  </editor>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="blockTypes.DYNAMIC">
              <ng-container *ngIf="blockGuards.isDynamic(item)">
                <div class="doc-block-visibility">
                  <ndc-dynamic
                    [ndcDynamicComponent]="item.component"
                    [ndcDynamicInputs]="item.inputs"
                  ></ndc-dynamic>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="blockTypes.PAGE_BREAK">
              <div class="page-break"></div>
            </ng-container>
          </ng-container>
          <div class="doc-block-controls-inner" data-print-ignore>
            <div class="hstack gap-1">
              <mat-button-toggle
                #toggle
                [checked]="!item.hidden"
                *ngIf="item.required"
                (change)="toggleVisibilityAt(item)"
              >
                <mat-icon
                  svgIcon="visibility"
                  *ngIf="toggle.checked"
                ></mat-icon>
                <mat-icon
                  svgIcon="visibility_hidden"
                  *ngIf="!toggle.checked"
                ></mat-icon>
              </mat-button-toggle>

              <button luiCab *ngIf="!item.required" (click)="remove(item)">
                <mat-icon svgIcon="trash"></mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="doc-block-controls" data-print-ignore>
          <div class="doc-block-controls-safe-zone"></div>
          <div class="vstack gap-1">
            <button
              luiCab
              (click)="addItemAfter(item)"
              matTooltip="Insert below"
              matTooltipPosition="right"
            >
              <mat-icon svgIcon="row_insert_bottom"></mat-icon>
            </button>
            <button
              luiCab
              (click)="addItemBefore(item)"
              matTooltip="Insert above"
              matTooltipPosition="right"
            >
              <mat-icon svgIcon="row_insert_top"></mat-icon>
            </button>
            <button
              luiCab
              (click)="insertPageBreak(item)"
              matTooltip="Insert page break"
              matTooltipPosition="right"
            >
              <mat-icon svgIcon="page_break"></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</div>
